import { ApiService } from "@core/api/api-service";

import { CreatePtInput, PtInvitation, ValidatePtInput } from "@domain/register/register";

interface CountryCodeResponse {
	locale: string;
}

type PtInvitationDto = Omit<PtInvitation, "id">;

export class RegisterService {
	constructor(
		private readonly authenticatedApiService: ApiService,
		private readonly unauthenticatedApiService: ApiService,
	) {}

	async fetchPtInvitation(invitationId: string): Promise<PtInvitation> {
		const result = await this.unauthenticatedApiService.get<PtInvitationDto>(`/pts/invitations/${invitationId}`);
		return { ...result.data, id: invitationId };
	}

	async sendCountryCode(countryCode: string): Promise<CountryCodeResponse> {
		return (await this.unauthenticatedApiService.post<CountryCodeResponse>("/localization/locale", { countryCode }))
			.data;
	}

	async sendRegistrationData(data: CreatePtInput): Promise<void> {
		await this.authenticatedApiService.post<void>("/pts/register", data);
	}

	async validateProfessionalInfo(data: ValidatePtInput): Promise<void> {
		await this.authenticatedApiService.post<void>("/pts/professional-information", data);
	}
}
